import { render } from "./AIWritingTest.vue?vue&type=template&id=4f97156c&scoped=true"
import script from "./AIWritingTest.vue?vue&type=script&lang=js"
export * from "./AIWritingTest.vue?vue&type=script&lang=js"

import "./AIWritingTest.vue?vue&type=style&index=0&id=4f97156c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f97156c"]])

export default __exports__